import { render, staticRenderFns } from "./TechnicalDetails.vue?vue&type=template&id=f184fc74&scoped=true"
import script from "./TechnicalDetails.vue?vue&type=script&lang=js"
export * from "./TechnicalDetails.vue?vue&type=script&lang=js"
import style0 from "./TechnicalDetails.vue?vue&type=style&index=0&id=f184fc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f184fc74",
  null
  
)

export default component.exports